import { createSlice } from '@reduxjs/toolkit';

export const OrgDB = createSlice({
    name: 'org',
    initialState: {
        name: '',
        code: '',
        email: '',
        phone: '',
        loading: false,
        create: {
            name: '',
            given_name: '',
            family_name: '',
            email: '',
            phone_number: '',
            phone: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            status: true
        }
    },
    reducers: {
        setLoading: (state, action) => {
            return{
                ...state,
                loading:action.payload
            }
        },

        resetOrg: (state, action) =>{
            return {
                ...state,
                create: {
                    name: '',
                    code: '',
                    email: '',
                    phone_number: '',
                    phone: '',
                    status: true
                }
            }
        },
        
        orgCreate: (state, action) =>{
            var cc = {
                ...state.create,
                ...action.payload
            }
            return {
                ...state,
                create: cc
            }
        }
    }
})

export const { orgCreate, setLoading, resetOrg } = OrgDB.actions

export default OrgDB.reducer